import { useState } from "react";

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = JSON.parse(window.localStorage.getItem(key) ?? "null");

      if (item === null && initialValue) {
        window.localStorage.setItem(key, JSON.stringify(initialValue));
        return initialValue;
      }

      return item ?? initialValue;
    } catch {
      localStorage.removeItem(key);
      return initialValue;
    }
  });

  const setValue = (value: T | ((val: T) => T)) => {
    const valueToStore = value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    window.localStorage.setItem(key, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue] as const;
}
